import { generateSideServices } from "./generate-side-services";

export function generateSideMenuServicesRow(cat:any,index:any){
    let sideMenuServices:any = [];
    cat.menu.forEach((ser:any)=>{
        sideMenuServices.push(generateSideServices(ser));
    });
    $('.services-list#'+index).empty()
    $('.services-list#'+index).append(sideMenuServices);
}